import {take, range, partial} from 'lodash'
import moment from 'moment'
import React from 'react'
import Text from 'react-text'
import {useDrop} from 'react-dnd'
import {Consumer} from '../../context'
import {rescheduleEvent} from '../../context/post'
import Toolbar, {changeView} from './toolbar'
import Filters from './filters'
import Label from '../label'
import Event from './event'
import './week.styl'

const dayTitleHeight = 28
const eventHeight = 28
const horizontalMargin = 40 
const verticalMargin = 300
const groupWidth = 200
const groupStyle = {with: groupWidth, maxWidth: groupWidth, minWidth: groupWidth}

function Day (props) {
  const {date, daySize, group, goToDay} = props
  const day = moment(date).format('YYYY-MM-DD')
  const isToday = moment(date).isSame(new Date(), 'day')
  const className=`day ${isToday ? 'current' : ''}`
  const displayCount = 3
  const [collectedProps, drop] = useDrop({
    accept: 'event',
    canDrop: () => {
      return moment(date).isSameOrAfter(new Date(), 'day')
    },
    drop: ({id}) => {
      const event = props.context.events.find(e => e.id == id)
      if (event) {
        const duration = moment.duration(moment(date).diff(moment(event.start))).asDays()
        const finish = moment(event.end).add(duration, 'days')
        rescheduleEvent(id, date, finish).then(() => {
          const eventUpdates = props.context.eventUpdates + 1
          props.context.setState({eventUpdates})
        })
      }
    }
  })
  return (<Consumer>{ context => {
    const events = (context.eventsByDay[day] || [])
      .filter(event => event.group == group.id)
    return (
      <div
        ref={drop}
        className={className}
        style={daySize}
        onClick={() => goToDay({start: day, end: day, group: group.id})}
      >
        <div className="events">
          {take(events, displayCount).map((props, i) => (<Event key={i} {...props}/>))}
        </div>
      </div>
    )
  }}</Consumer>)
}

function Week(props) {
  const {start, daySize, context, group, goToDay} = props 
  const days = range(7)
    .map(d => ({goToDay, group, context, daySize, date: moment(start).add(d, 'days')}))
    .map((props,i) => (<Day key={i} {...props}/>))
  const subjectId = group.course.substring(0,2)
  const subject = context.subjects.find(subject => subject.id == subjectId)
  return (
    <div className="week">
      <div className="group" style={groupStyle}>
        <div className="color-band" style={{backgroundColor: subject.color}}/>
        <div className="title">
          <div className="subject">
            {`${group.subject} - ${group.grade}`}
          </div>
          <div className="name">
            {group.name}
          </div>
        </div>
      </div>
      {days}
    </div>
  )
}

function Header(props) {
  const {date, daySize} = props
  return (
    <div
      className="header day"
      style={{width: daySize.width}}
    >
      {date.format('ddd DD/MM')}
   </div>)
}



export default function WeekView (props) {

  const {date} = props
  const start = date().startOf('week')
  const end = date().endOf('week')

  return (<Consumer>{ context => {
    const {sizes, groups, query} = context
    const goToDay = partial(changeView(context), 'day')
    const dayWidth = Math.round((sizes.width - horizontalMargin - groupWidth - 12) / 7)
    const daySize = {
      width: dayWidth, maxWidth: dayWidth, minWidth: dayWidth
    }

    const weeks = groups
      .filter(group => !query.group || query.group == group.id)
      .map(group => ({goToDay, context, group, start, daySize}))
      .map((props,i) => (<Week key={i} {...props}/>))

    const headers = range(7)
      .map(d => ({date: moment(start).add(d, 'days'), daySize}))
      .map((props,i) => (<Header key={i} {...props}/>))

    return (
      <div className="calendar week view" style={{width: sizes.width - horizontalMargin}}>
        <Toolbar {...props} />
        <div className="calendar">
          <Filters />
          <div className="headers">
            <div className="header groups" style={groupStyle}>
              <Text id="groups_label" />
            </div>
            {headers}
          </div>
          <div className="weeks">
            {weeks}
          </div>
        </div>
      </div>
    )}}</Consumer>)
}
